
import React, { useState } from 'react';
import { Redirect } from 'react-router';
import { hot } from 'react-hot-loader';
import { compose } from 'recompose';
import styled from 'styled-components';
import { Form, Button, Checkbox, Message, Image } from 'semantic-ui-react'

import { withLocale } from 'op/components/locale';
import { withLoginForm } from './login.helper';
import LogoImage from 'op/public/logo.png';
import TermsConditionsPopup from '../../components/auth/termsConditions-modal.component'
import ForgetPasswordPopup from '../../components/auth/forgetPassword-modal.component'

const LoginContainer = styled.div`
	min-height: 100vh;
	width: 100%;
	padding: 3rem;

	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	form.ui {
		width: 100%;
		max-width: 500px;	
	}
`;

const LogoContainer = styled.div`
	padding-bottom: 6rem;
`;

const CheckboxContainer = styled.div`
	padding-top: 3rem;
`;

const WideSubmit = styled(Button)`
	width: 100%;
	background-color: ${props => props.theme.light} !important;
	color: ${props => props.theme.dark} !important;
`;




const Login = ({ locale, loggedIn, next, login, error, loading, username, setUsername, password, setPassword }) => {
	const [check, setChecked] = useState(true)

	const onChangeHandler = (e, { checked }) => {
		setChecked(!checked)
	}

	return loggedIn ? (
		<Redirect push to={next} />
	) : (
			<LoginContainer>
				<LogoContainer>
					<Image src={LogoImage} />
				</LogoContainer>
				<Form onSubmit={login} loading={loading} error={!!error}>
					<Form.Input placeholder={locale.username} type='text' value={username} onChange={(e) => setUsername(e.target.value)} />
					<Form.Input placeholder={locale.password} type='password' value={password} onChange={(e) => setPassword(e.target.value)} />
					<Message
						error
						header={locale.error.header}
						content={error=='expired'?locale.error.contentExpired:locale.error.content}
					/>
					<WideSubmit type='submit' disabled={check}>{locale.submit} </WideSubmit>
				</Form>
				<CheckboxContainer><Checkbox label={{ children: 'I agree with the' }} onChange={onChangeHandler} />&nbsp;<TermsConditionsPopup locale={locale} /> </CheckboxContainer>
				<ForgetPasswordPopup locale={locale} />
			</LoginContainer>
		)
};

export default compose(
	withLocale('login'),
	withLoginForm,
	hot(module),
)(Login);
